import { useEffect, useRef } from 'react';
import { useGridApiContext } from '@mui/x-data-grid';
import useDashboardCompact from '../../../styles/theme/surfaces/useDashboardCompact';

/**
 * Keeps a mounted DataGrid's density in step with the compact dashboard. The
 * theme sets the starting density through `initialState`, which only applies
 * on mount, so a grid already on screen when the window crosses xl would keep
 * the old density. This calls `setDensity` only when `compact` changes; on
 * mount it does nothing, and a density picked in GridActionsMenu stays
 * until the next breakpoint change. Render it inside the grid's toolbar slot
 * (it needs the grid context); it renders nothing.
 */
export default function GridCompactDensitySync() {
  const apiRef = useGridApiContext();
  const compact = useDashboardCompact();
  const previous = useRef(compact);

  useEffect(() => {
    if (previous.current === compact) return;
    previous.current = compact;
    apiRef.current.setDensity(compact ? 'compact' : 'standard');
  }, [apiRef, compact]);

  return null;
}
